/**
 * Resolve a safe in-app path from ?redirect= query param (open-redirect safe).
 */
export function getPostLoginRedirect(search, fallback = '/dashboard') {
  const redirect = new URLSearchParams(search).get('redirect');
  if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
    return redirect;
  }
  return fallback;
}
